import { render } from "./fixedBottom.vue?vue&type=template&id=25cffa2e&scoped=true"
import script from "./fixedBottom.vue?vue&type=script&lang=js"
export * from "./fixedBottom.vue?vue&type=script&lang=js"

import "./fixedBottom.vue?vue&type=style&index=0&id=25cffa2e&lang=less&scoped=true"

import exportComponent from "/Users/aiden/Desktop/hujian/hongyu/edu-web-mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25cffa2e"]])

export default __exports__